import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { App } from './App';
import { ChunkErrorBoundary } from './components/ChunkErrorBoundary';
import { PresentationMaskUnavailable, PresentationModeBadge } from './components/common/PresentationModeBadge';
import { AuthProvider } from './hooks/useAuth';
import { logError } from './lib/logger';
import { installPreloadErrorReload } from './lib/preloadErrorReload';
import { initPresentationMode } from './lib/presentationMode';
import { registerServiceWorker } from './lib/registerSW';
import { initTheme } from './lib/theme';

registerServiceWorker();
// A tab left on the previous build after a deploy reloads once onto the new one.
installPreloadErrorReload();
// Before the first paint: the theme the viewer chose, or the system's (PLAN-BUREAU § 4 quater).
initTheme();

function render() {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <ChunkErrorBoundary>
        <AuthProvider>
          <App />
        </AuthProvider>
        <PresentationModeBadge />
      </ChunkErrorBoundary>
    </StrictMode>
  );
}

// The presentation mode masks the charts and the amounts written in prose before anything is drawn; off, neither
// mask is even loaded. Without its masks, the application stays hidden rather than show its figures.
if (initPresentationMode()) {
  Promise.all([import('./lib/presentationCharts'), import('./lib/presentationProse')])
    .then(([{ installChartMask }, { installProseMask }]) => {
      installChartMask();
      installProseMask();
      render();
    })
    .catch((err: unknown) => {
      logError('presentation', 'masks failed to install', err);
      createRoot(document.getElementById('root')!).render(<PresentationMaskUnavailable />);
    });
} else {
  render();
}